'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformLink = transformLink;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _browser = require('@beastshop/browser');

var _browser2 = _interopRequireDefault(_browser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REG = /^beastapp:\/\/(\S+)[\?\/]([\S\s]+)/i;

var route = {
  'index': '/',
  'shop': '/shop?shopId=',
  'brand': '/product/list?',
  'cate': '/product/list?',
  'search': '/product/list?',
  'retail': '/retail?',
  'article': '/article?articleId=',
  'customization-list': '/customization/list?',
  'big-furniture-tips': '/furniture/tips?',
  'shop-story': '/shop/story?',
  'group-purchase': '/group/purchase?',
  'points-benefit': '/points/benefit?',
  'points-mall': '/member/day/points?',
  'points-detail': '/member/day/points/detail?',
  'points-coupon': '/points/coupon?',
  'category': '/category?',
  'store': '/store?',
  'cart': '/cart?',
  'member': '/my?',
  'discovery': '/discovery?'
};

var params = {
  'brand': 'brandId'
};

var app = _browser2.default.app();

function transformLink(_ref) {
  var link = _ref.link,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$shopId = _ref.shopId,
      shopId = _ref$shopId === undefined ? '' : _ref$shopId;

  if (!link.type) {
    return '';
  }
  var url = "";
  if (app) {
    url = 'beastapp://';
  }
  title = encodeURIComponent(title);
  switch (link.type) {
    case 'none':
      return '#';
      break;
    case 'product':
      app ? url += 'product/' + link.value : url = '/product/' + link.value;
      break;
    case 'article':
      app ? url += 'article/' + link.value : url = '/article?articleId=' + link.value;
      break;
    case 'shop-story':
      app ? url += 'entry?name=shop-story&shopId=' + link.value : url = '/shop/story?shopId=' + link.value;
      break;
    case 'shop':
      app ? url += 'shop/' + link.value : url = '/shop?shopId=' + link.value;
      break;
    case 'list':
      app ? url += 'search?listId=' + link.value + '&title=' + title : url = '/product/list?listId=' + link.value + '&title=' + title;
      break;
    case 'new':
      app ? shopId ? url += 'search?shopId=' + shopId + '&new=1&title=' + title : url += 'search?new=1&title=' + title : shopId ? url = '/product/list?shopId=' + shopId + '&new=1&title=' + title : url = '/product/list?new=1&title=' + title;
      break;
    case 'all':
      app ? shopId ? url += 'search?shopId=' + shopId + '&title=' + title : url += 'search?title=' + title : shopId ? url = '/product/list?shopId=' + shopId + '&title=' + title : url = '/product/list?title=' + title;
      break;
    case 'brand':
      app ? url += 'search?brandId=' + link.value + '&title=' + title : url = '/product/list?brandId=' + link.value + '&title=' + title;
      break;
    case 'tag':
      app ? url += 'search?labelId=' + link.value + '&title=' + title : url = '/product/list?labelId=' + link.value + '&title=' + title;
      break;
    case 'bu':
      app ? url += 'search?buId=' + link.value + '&title=' + title : url = '/product/list?buId=' + link.value + '&title=' + title;
      break;
    case 'category':
      var cateStrs = '';
      link.value.split(',').forEach(function (v, index) {
        cateStrs += 'categoryId=' + v + '&';
      });

      app ? url += 'search?' + cateStrs + 'title=' + title : url = '/product/list?' + cateStrs + 'title=' + title;
      break;
    case 'oversea':
      app ? shopId ? url += 'search?shopId=' + shopId + '&overseasOnly=true&title=' + title : url += 'search?overseasOnly=true&title=' + title : shopId ? url += '/product/list?shopId=' + shopId + '&overseasOnly=true&title=' + title : url += '/product/list?overseasOnly=true&title=' + title;
      break;
    case 'categoryOversea':
      var cateStrs1 = '';
      link.value.split(',').forEach(function (v, index) {
        cateStrs1 += 'categoryId=' + v + '&';
      });

      app ? shopId ? url += 'search?shopId=' + shopId + '&overseasOnly=true&' + cateStrs1 + 'title=' + title : url += 'search?overseasOnly=true&' + cateStrs1 + 'title=' + title : shopId ? url += '/product/list?shopId=' + shopId + '&overseasOnly=true&' + cateStrs1 + 'title=' + title : url += '/product/list?overseasOnly=true&' + cateStrs1 + 'title=' + title;
      break;
    case 'article-list':
      var idStrs = '';
      link.value.split(',').forEach(function (v, index) {
        idStrs += 'articleId=' + v + '&';
      });
      app ? url += 'entry?name=article-list&type=article-list&' + idStrs + 'title=' + title : url = '/article/list?type=article-list&' + idStrs + 'title=' + title;
      break;
    case 'lesson':
      app ? url += 'entry?name=article-list&type=LESSON&title=' + title : url = '/article/list?type=LESSON&title=' + title;
      break;
    case 'group':
      app ? url += 'entry?name=group-purchase&productId=' + link.value : url = '/group/purchase?productId=' + link.value;
      break;
    case 'customization-list':
      app ? url += 'entry?name=customization-list' : url = '/customization/list';
      break;
    case 'deeplink':
      app ? url = link.value : url = dealMLink(link.value);
      break;

    case 'custom':
      app ? url += 'entry?name=customization-list' : url = '';
      break;
    case 'discount':
      app ? url += 'search?param=discount&title=\u6298\u6263' : url = '/product/list?param=discount&title=\u6298\u6263';
      break;
    case 'retail':
      app ? url += 'entry?name=retail&title=\u5B9E\u4F53\u5E97' : url = '/retail';
      break;
    case 'index':
      app ? url += 'index' : url = '/';
      break;
  }
  return { url: url };
}

function dealMLink(link) {
  if (link === 'beastapp://index') {
    link = '/';
  } else {
    link = splitQue(link);
  }

  return link;
}

function splitQue(query) {
  var que = REG.exec(query);
  var type = que[1];
  var search = que[2];
  var name = '';
  // entry
  if (type === 'entry') {
    type = _queryString2.default.parse(search).name;
  }

  if (type && search) {
    que = matchQue(type, search);
  }

  return que;
}

function matchQue(type, query) {
  var que = '';
  type = type.split('/');

  var path = route[type[0]];
  var pid = params[type[0]];

  if (path) {
    que = type[1] && pid ? '' + path + pid + '=' + type[1] + '&' + query : pid ? '' + path + pid + '=' + query : '' + path + query;
  } else {
    que = '/' + type[0].replace('-', '/');
  }

  return que;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/sdk/lib/navigate/link/app-web.js
// module id = 992
// module chunks = 0